import { buttonVariants } from "@arcadeai/design-system/components/ui/atoms/button";
import { cn } from "@arcadeai/design-system/lib/utils";
import { Link } from "@tanstack/react-router";
import { Code, MessageSquareIcon } from "lucide-react";
import type { ReactNode } from "react";

type TabItem = {
  to: string;
  icon: ReactNode;
  label: string;
};

const TABS: TabItem[] = [
  {
    to: "/chat",
    icon: <MessageSquareIcon className="size-4" />,
    label: "Chat",
  },
  {
    to: "/execute",
    icon: <Code className="size-4" />,
    label: "Execute",
  },
];

export function PlaygroundTabs() {
  return (
    <nav
      aria-label="Playground navigation"
      className="flex w-fit gap-2 rounded-lg bg-muted p-1"
    >
      {TABS.map(({ to, icon, label }) => (
        <Link
          activeProps={{
            className: cn(
              buttonVariants({ variant: "secondary", size: "sm" }),
              "bg-background"
            ),
            "aria-current": "page",
          }}
          className={cn(
            buttonVariants({ variant: "ghost", size: "sm" }),
            "flex items-center gap-2 hover:bg-background dark:hover:bg-background"
          )}
          from="/orgs/$organizationId/projects/$projectId/playground"
          key={to}
          // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
          to={`.${to}` as "./chat" | "./execute"}
        >
          {icon}
          <span>{label}</span>
        </Link>
      ))}
    </nav>
  );
}
